import { PlayerSummary } from '@inplay/models';
import { ReactNode } from 'react';
import { PlayerRisk } from '../../component/playerIcon/playerIcon.types';

export type DashboardProps = {};

export type CardSummary = {
  title: ReactNode;
  value: number | string;
};

export enum DashboardViews {
  RADIAL = 'Radial',
  LIST = 'List',
}

export type PlayerWithRisk = PlayerSummary & {
  risk: PlayerRisk;
};

export type GroupedPlayersData = {
  low: PlayerWithRisk[];
  intervention_offered: PlayerWithRisk[];
  intervention_required: PlayerWithRisk[];
  excluded: PlayerWithRisk[];
};

export type LegendData = {
  icon: ReactNode;
  text: string | ReactNode;
};

export enum HourlySweepStatus {
  COMPLETED = 'completed',
  MISSED = 'missed',
  PENDING = 'pending',
}

export enum HourlySweepStatusColors {
  COMPLETED = '#5EEDD1',
  MISSED = '#FF7979',
  PENDING = '#D5D6E8',
  VOLUNTARY = '#C4C6FF',
}

export type HourlySweep = {
  sweepTime?: Date;
  status: HourlySweepStatus;
  sweepSchedule?: string;
};

export type HourlySweepData = {
  obligatory: HourlySweep[];
  voluntary: HourlySweep[];
};
